import { ComponentPortal, DomPortalOutlet } from "@angular/cdk/portal";
import {
  ApplicationRef,
  ComponentFactoryResolver,
  Injectable,
  Injector,
} from "@angular/core";
import { OverlayComponent } from "@generic/overlay/overlay.component";
import { NbDialogService } from "@nebular/theme";

export interface OverlayOpenInput {
  title?: string;
  content?: string;
  showSpinner?: boolean;
  overlayStyles?: object;
}

@Injectable({
  providedIn: "root",
})
export class OverlayService {
  componentRef;
  portalOutlet: DomPortalOutlet;
  hostContainer: HTMLDivElement;
  public overlays: any[] = [];
  constructor(
    public dialog: NbDialogService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector
  ) {}

  open(
    settings: OverlayOpenInput = {
      title: "",
      content: "",
      showSpinner: true,
      overlayStyles: {},
    },
    name?: string | undefined
  ) {
    const hostContainer = document.createElement("div");
    const overlay = { name: name || "default", settings, hostContainer };
    this.overlays.push(overlay);
    this.openOverlay(overlay);
  }

  openOverlay(overlay) {
    const { title, content, showSpinner, overlayStyles } = overlay.settings;
    const componentPortal = new ComponentPortal(OverlayComponent);
    document.body.appendChild(overlay.hostContainer);
    this.portalOutlet = new DomPortalOutlet(
      overlay.hostContainer,
      this.componentFactoryResolver,
      this.appRef,
      this.injector
    );

    this.componentRef =
      this.portalOutlet.attachComponentPortal(componentPortal);
    this.componentRef.instance.title = title;
    this.componentRef.instance.content = content;
    this.componentRef.instance.showSpinner =
      showSpinner === false ? false : true;
    this.componentRef.instance.overlayStyles = overlayStyles;
  }

  close(name = "default") {
    try {
      this.overlays = this.overlays.filter((overlay) => {
        if (overlay.name === name) {
          this.portalOutlet.detach();
          document.body.removeChild(overlay.hostContainer);
          return false;
        }
        return true;
      });
    } catch (error) {}
  }
}
